import { IGetAllColetaProdutoServicoUseCase } from "../../../presentation/useCases/read/get_all_coleta_produto_servico_use_case";
import { ColetaProdutoServicoLista } from "../../models/coleta_produto_servico_lista";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllColetaProdutoServicoUseCase
 */

export class GetAllColetaProdutoServicoUseCase implements IGetAllColetaProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllColetaProdutoServico(
    idColetaPrecoFornecedor: number,
  ): Promise<ColetaProdutoServicoLista[]> {
    return await this.repository.getAllColetaProdutoServico(
      idColetaPrecoFornecedor,
    );
  }
}
